export default "__VITE_ASSET__BJvxvN$l__"